import { useMutation } from 'react-query'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ManagementAddNewLoanValidate } from 'services/loans/manager'

export default function useValidateInstallments() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IManagementBodyValidate) => {
            return ManagementAddNewLoanValidate(payload)
        },
        onSuccess: (data) => {
            if (data.is_valid) {
                navigate('/loans/add-old/management/final/add', {
                    state: { ...state },
                })
            } else {
                if (data.amount_errors.length > 0) {
                    toast.error('مقدار وارد شده برای قسط ها اشتباه است')
                }
                if (data.due_date_errors.length > 0) {
                    toast.error('تاریخ وارد شده برای قسط ها اشتباه است')
                }
            }
        },
        onError: () => {
            toast.error('خطایی پیش آمده!')
        },
    })

    return { mutate }
}
